import React from 'react';
import { useTranslation } from 'react-i18next';
import { unescapeHTML } from 'underscore.string';
import { NavLink } from 'react-router-dom';
import { Menu } from '@headlessui/react';
import CargomaticLogo from 'img/cargomatic-logo-dark.png';
import SessionStore from 'stores/SessionStore';
import classNames from 'classnames';
import Navbar from '../v2/navs/Navbar';
import UserActionCreators from '../../actions/UserActionCreators';
import DropdownMenu from '../v2/dropdowns/DropdownMenu';
import { Avatar } from '../modules/user/Avatar';
import LanguageSelector from './language-selector';
function logout() {
    UserActionCreators.logout();
}
export default function ConsigneeNavigation() {
    const consignee = SessionStore.getUser();
    const { t } = useTranslation();
    function renderMobileNav(onClose) {
        return [
            React.createElement(NavLink, { className: "nav-item", to: "/tracking", onClick: onClose, key: "mobile-tracking" },
                React.createElement("span", null, t('TRACKING'))),
            React.createElement(NavLink, { className: "nav-item", to: "/appointments", onClick: onClose, key: "appointments-tracking" },
                React.createElement("span", null, t('APPOINTMENTS'))),
            React.createElement(NavLink, { className: "nav-item", to: `/consignee/${consignee === null || consignee === void 0 ? void 0 : consignee._id}`, onClick: onClose, key: "mobile-profiles" },
                React.createElement("span", null, t('MY_PROFILE'))),
            React.createElement("div", { key: "language-selector-mobile", className: classNames('nav-item', {
                    hidden: LANGUAGE_SELECTION_DISABLED,
                }) },
                React.createElement(LanguageSelector, { mobile: true })),
            React.createElement("a", { href: "#", className: "nav-item", onClick: logout, key: "mobile-signout" }, t('SIGN_OUT')),
        ];
    }
    function renderRightNav() {
        const name = SessionStore.getUser().name;
        const userId = SessionStore.getUser()._id;
        let profileButton = null;
        profileButton = (React.createElement("div", { title: unescapeHTML(name), className: "flex text-sm bg-gray-800 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-gray-800 focus:ring-white", "aria-haspopup": "true" },
            React.createElement(Avatar, { key: userId, userId: userId, altName: "Logo", className: "w-8 h-8 rounded-full" })));
        return [
            React.createElement("div", { key: "language-selector", className: classNames('flex items-center justify-center nav-item mr-2', { hidden: LANGUAGE_SELECTION_DISABLED }) },
                React.createElement(LanguageSelector, null)),
            React.createElement(DropdownMenu, { title: "Carrier Center", button: profileButton, isDark: true, key: "main-dropdown" },
                React.createElement(Menu.Item, { key: "profile" },
                    React.createElement(NavLink, { activeClassName: "active-light", className: "nav-item", to: `/consignee/${consignee === null || consignee === void 0 ? void 0 : consignee._id}` },
                        React.createElement("span", null, t('MY_PROFILE')))),
                React.createElement(Menu.Item, { key: "sign-out" },
                    React.createElement("a", { href: "#", className: "nav-item", onClick: logout }, t('SIGN_OUT')))),
        ];
    }
    const brandLogo = (React.createElement(NavLink, { to: "/" },
        React.createElement("img", { alt: "Cargomatic", src: CargomaticLogo, style: { height: 25 } })));
    return (React.createElement(Navbar, { logo: brandLogo, renderRightNav: renderRightNav, renderMobileNav: renderMobileNav },
        React.createElement(NavLink, { className: "nav-item", to: "/tracking", key: "Tracking" },
            React.createElement("span", null, t('TRACKING'))),
        React.createElement(NavLink, { className: "nav-item", to: "/appointments", key: "Appointments" },
            React.createElement("span", null, t('APPOINTMENTS')))));
}
